import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { CheckboxWithLabel } from '@myn/mui'; // TODO: Replace with tw-pattern when available

type Props = {
  isChecked: boolean;
  onChangeCheck: () => void;
};

const SecondStep = ({ isChecked, onChangeCheck }: Props) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <>
      <div className="flex flex-col">
        <p
          className={cn(
            'mb-2',
            typographyVariants({
              variant: 'h4',
            }),
          )}
        >
          {t('Create a new Buying Plan version or update current one?')}
        </p>
        <p
          className={typographyVariants({
            variant: 'bodyLong02',
            color: 'secondary',
          })}
        >
          {t(
            "You accepted a suggestion. You can now decide if you'd like to create a new version of the Buying Plan or update the current one.",
          )}
        </p>
      </div>
      <div className="mt-2 flex flex-row">
        <CheckboxWithLabel
          checked={isChecked}
          onChange={onChangeCheck}
          label={t("Don't ask me again")}
        />
      </div>
    </>
  );
};

export default SecondStep;
